import { SVGAttributes } from 'react'

const DragIcon = (props: SVGAttributes<SVGElement>) => (
    <svg fill={props.color || 'white'} viewBox="0 0 18 16" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0.999999C0 0.447714 0.447715 0 1 0H17C17.5523 0 18 0.447715 18 1V1.8C18 2.35229 17.5523 2.8 17 2.8H1C0.447716 2.8 0 2.35228 0 1.8V0.999999ZM0 7.6C0 7.04771 0.447715 6.6 1 6.6H17C17.5523 6.6 18 7.04772 18 7.6V8.4C18 8.95229 17.5523 9.4 17 9.4H1C0.447716 9.4 0 8.95228 0 8.4V7.6ZM0 14.2C0 13.6477 0.447715 13.2 1 13.2H17C17.5523 13.2 18 13.6477 18 14.2V15C18 15.5523 17.5523 16 17 16H1C0.447716 16 0 15.5523 0 15V14.2Z"
        />
    </svg>
)
export default DragIcon
